<template>
  <div class="orders-filters">
    <animated-dropdown label="Select a time frame"
                       :index="1"
                       :disabled="loading"
                       :options="timeFrameOptions"
                       :select-multiple="false"
                       :show-label-when-selected="false"
                       close-on-select
                       @changed="onFilterChanged"></animated-dropdown>
    <button class="btn btn-accent-1 orders-filters__refresh-button"
            :disabled="loading"
            @click="onRefresh">
      <font-awesome-icon :icon="['fas', 'sync-alt']"></font-awesome-icon>
      Refresh
    </button>
  </div>
</template>

<script>
import AnimatedDropdown from "~/Components/Base/AnimatedDropdown.vue";

export default {
  name: "OrdersFilter",
  components: {
    AnimatedDropdown,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      timeFrameOptions: [
        {
          key: "month",
          value: "Last 30 Days",
        },
        {
          key: "six-months",
          value: "Last 6 Months",
        },
        {
          key: "year",
          value: "Last Year",
        },
        {
          key: "all",
          value: "All Orders",
        },
      ],
    };
  },
  methods: {
    onRefresh () {
      this.$emit( "refresh" );
    },
    onFilterChanged ( val ) {
      this.$emit( "change", val );
    },
  },
};
</script>

<style lang="less" scoped>
.orders-filters {
  display: flex;
  align-items: center;

  /deep/ .checkbox {
    background-color: #fff;

    &__container {
      margin: 0;
      margin-right: 20px;
    }
  }

  &__refresh-button {
    margin-left: auto;
  }
}
</style>
